module.exports = __webpack_public_path__ + "static/media/Finnovex-Middle-East-2024.5903d5ff.png";